export default __webpack_public_path__ + "img/question.933a166.svg";